import { AddressForm } from 'components/addressForm/addressForm';
import { DisplayInfo } from 'components/displayInfo/displayInfo';

import template from './billingAddressForm.html';
import './billingAddressForm.scss';

export const BillingAddressForm = angular
    .module('checkout.components.billingAddressForm', [
        DisplayInfo,
        AddressForm
    ]).component('billingAddressForm', {
        template,
        bindings: {
            billingSameAsShipping: '<',
            model: '='
        },
        controller: class BillingAddressFormCtrl {
            onChangeBillingAddressClicked() {
                this.billingSameAsShipping = false;
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/billingAddressForm/billingAddressForm.js